import { defineMessages } from 'react-intl';

export default defineMessages({
  relevantProjectsDropdownHeading: {
    id: 'frontbucket.jiraTab.relevantProjects.title',
    description:
      'Title text of drop down menu which contains relevant Jira projects.',
    defaultMessage: '{count, plural, one {Jira project} other {Jira projects}}',
  },
  relevantProjectsDropdownTrigger: {
    id: 'frontbucket.jiraTab.relevantProjects.trigger',
    description:
      'Trigger text of drop down menu which contains relevant Jira projects.',
    defaultMessage: 'Project',
  },
  errorMessage: {
    id: 'frontbucket.jiraTab.relevantProjects.errorMessage',
    description: 'Message displayed when it fails to load the assignees',
    defaultMessage: `We can't load the project list.`,
  },
});
